import _objectSpread from "/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import platform from './node/index.js';
import * as utils from './common/utils.js';
export default _objectSpread(_objectSpread({}, utils), platform);